import LinkTypeEnum from 'redpoints-model-js/enumeration/LinkTypeEnum';

import LinksManagementSetLinkStatusEnum from '../../../enumerations/LinksManagementSetLinkStatusEnum';

const LINK_MANAGEMENT_TEXT_MAX_ROWS = 1000;
const LINEBREAK_SEPARATOR_REGEX = /[\n]+/;

export const generateUrlsList = value => {
  const trimmed = value.toString().trim();

  return trimmed === '' ? [] : trimmed.split(LINEBREAK_SEPARATOR_REGEX);
};

export const isUrlsLimitValid = value =>
  generateUrlsList(value).length <= LINK_MANAGEMENT_TEXT_MAX_ROWS;

export const transformUrlsToLinkObjects = urls =>
  generateUrlsList(urls).map(url => ({
    url,
    status: LinksManagementSetLinkStatusEnum.WAITING,
  }));

export const getFailedRelaunchEnforcedLinks = relaunchEnforcementLinks => {
  const failedLinks = {
    [LinkTypeEnum.DETECTION.name]: '',
    [LinkTypeEnum.CONTENT.name]: '',
  };

  const detectionLinkErrors =
    relaunchEnforcementLinks?.[LinkTypeEnum.DETECTION.name];
  const contentLinkErrors =
    relaunchEnforcementLinks?.[LinkTypeEnum.CONTENT.name];

  if (detectionLinkErrors) {
    Object.keys(detectionLinkErrors).forEach(url => {
      if (detectionLinkErrors[url].error) {
        failedLinks[LinkTypeEnum.DETECTION.name] += `${url}\n`;
      }
    });
  }

  if (contentLinkErrors) {
    Object.keys(contentLinkErrors).forEach(url => {
      if (contentLinkErrors[url].error) {
        failedLinks[LinkTypeEnum.CONTENT.name] += `${url}\n`;
      }
    });
  }

  return failedLinks;
};
